var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search-svgrepo-com (1) 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.91646 14.166C9.34146 14.166 10.6556 13.6885 11.7081 12.8852L15.6606 16.8385C15.8178 16.9903 16.0283 17.0743 16.2468 17.0724C16.4653 17.0705 16.6743 16.9829 16.8288 16.8284C16.9833 16.6739 17.071 16.4649 17.0729 16.2464C17.0747 16.0279 16.9908 15.8174 16.839 15.6602L12.8856 11.7069C13.7409 10.5857 14.1919 9.20831 14.1654 7.79843C14.1389 6.38855 13.6363 5.02908 12.7395 3.94092C11.8426 2.85276 10.6041 2.09987 9.22526 1.80459C7.8464 1.5093 6.4082 1.68899 5.14437 2.31444C3.88054 2.93989 2.86535 3.97435 2.26378 5.24972C1.66221 6.52509 1.50961 7.96641 1.83077 9.33948C2.15193 10.7125 2.92798 11.9367 4.03281 12.8129C5.13765 13.6891 6.50633 14.166 7.91646 14.166ZM12.4998 7.91602C12.4998 9.1316 12.0169 10.2974 11.1574 11.1569C10.2978 12.0165 9.13203 12.4994 7.91646 12.4994C6.70088 12.4994 5.53509 12.0165 4.67555 11.1569C3.81601 10.2974 3.33312 9.1316 3.33312 7.91602C3.33312 6.70045 3.81601 5.53466 4.67555 4.67512C5.53509 3.81558 6.70088 3.33269 7.91646 3.33269C9.13203 3.33269 10.2978 3.81558 11.1574 4.67512C12.0169 5.53466 12.4998 6.70045 12.4998 7.91602Z",
    fill: "#707070"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.e3dbbed0756ebf79042f92f5b1d46fc1.svg";
export { ForwardRef as ReactComponent };